import * as React from 'react'
import { ValueComponentProps } from '../../../props'
import BoolQuestionViewModel from '../../BoolQuestionViewModel'

export default function BoolValue({
  vm,
}: ValueComponentProps<BoolQuestionViewModel>) {
  return <>{vm.toTextAnswer()}</>
}
